import moment from "moment";
import { Encrption } from "../app-modules/encrption";
import { customAxios } from "./useExPressApi";
import { UserAuthResponse } from "src/dataModels/authDataModels";
import { API_ENDPOINTS } from "./api-endpoints";
import APP_ROUTES from "src/helper/app-routes";
import { store } from "src/redux/store/store";
import { changeAppRoute } from "src/redux/actions";

// ------------------------------Update clinic--------------------------------

const updateClinic = (fields, clinicId) => {


  let fullZip = fields?.zip + (fields?.zipOpt ? fields?.zipOpt : "")
  var data = {
    id: clinicId,
    address: fields?.address ? fields?.address : "",
    state: fields?.state ? fields?.state : "",
    city: fields?.city ? fields?.city : "",
    zip: fullZip.trim(),
    phone: fields?.phone ? fields?.phone : "",
    fax: fields?.fax ? fields?.fax : "",
    email: fields?.email ? fields?.email : "",
    websiteUrl: fields?.websiteUrl ? fields?.websiteUrl : "",
    npi: fields?.npi ? fields?.npi : "",
    startOfWeek: fields?.startOfWeek?.id ? fields?.startOfWeek?.id : "",
    taxnomy: fields?.taxnomy ? fields?.taxnomy : "",
    roundUp: fields?.roundUp,
    taxId: fields?.taxId ? fields?.taxId : "",
    openTime:fields?.businessStartHour ? moment(fields?.businessStartHour).format('HH:mm:ss') : "",
    closeTime:fields?.businessEndHour ? moment(fields?.businessEndHour).format('HH:mm:ss') : ""
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_CLINIC, data);
};

//  ----------------------------- Ref Provider ------------------------------

const insertClinicReferring = (fields) => {
  var data = {
    companyName: fields.companyName,
    firstName: fields.firstName,
    lastName: fields.lastName,
    npi: fields.npi,
    email: fields.email,
    contactPhone: fields.mobilePhone,
    address: fields.address,
    city: fields.city,
    state: fields.state,
    zip: fields.zipCode,
  };
  return customAxios.post(API_ENDPOINTS.INSERT_CLINIC_REFERRING_PROVIDER, data);
};

const getClinicReferringProvider = (clinicId, activeType) => {
  return customAxios.get(
    API_ENDPOINTS.GET_CLINIC_REFERRING +
    Encrption(clinicId) +
    "&isActive=" +
    activeType
  );
};

const deleteClinicRef = (id) => {
  return customAxios.delete(
    API_ENDPOINTS.DELETE_CLINIC_REFERRING + Encrption(id)
  );
};

const reActivateClinicReferring = (id) => {
  return customAxios.get(
    API_ENDPOINTS.REACTIVATE_CLINIC_REFERRING + Encrption(id)
  );
};

const getRefProviderById = (id, activeType) => {
  return customAxios.get(
    API_ENDPOINTS.GET_CLINIC_REF_BY_ID + Encrption(id) + "&isActive=" + activeType
  );
};

const updateClinicReferring = (fields, id) => {
  var data = {
    companyName: fields.companyName,
    firstName: fields.firstName,
    lastName: fields.lastName,
    npi: fields.npi,
    email: fields.email,
    contactPhone: fields.mobilePhone,
    address: fields.address,
    city: fields.city,
    state: fields.state,
    zip: fields.zipCode,
    id: id,
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_CLINIC_REFERRING_PROVIDER, data);
};

//  ----------------------------- Ref Source ------------------------------

const insertRefSource = (fields) => {
  var data = {
    referringCompanyName: fields.companyName,
    referringCompanyNPI: fields.npi,
    contactPerson: fields.contactPerson,
    contactPersonPosition: fields.position,
    contactPhone: fields.mobilePhone,
    contactEmail: fields.email,
    contactFax: fields.fax,
    address: fields.address,
  };
  return customAxios.post(API_ENDPOINTS.INSERT_REF_SOURCE, data);
};

const getRefSource = (clinicId, activeType) => {
  return customAxios.get(
    API_ENDPOINTS.GET_REF_SOURCE + Encrption(clinicId) + "&isActive=" + activeType
  );
};

const getRefSourceById = (id, activeType) => {
  return customAxios.get(
    API_ENDPOINTS.GET_REF_SOURCE_BY_ID + Encrption(id) + "&isActive=" + activeType
  );
};

const updateRefSource = (fields, id) => {
  var data = {
    referringCompanyName: fields.companyName,
    referringCompanyNPI: fields.npi,
    contactPerson: fields.contactPerson,
    contactPersonPosition: fields.position,
    contactPhone: fields.mobilePhone,
    contactEmail: fields.email,
    contactFax: fields.fax,
    address: fields.address,
    id: id,
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_REF_SOURCE, data);
};

const deleteRefSource = (id) => {
  return customAxios.delete(
    API_ENDPOINTS.DELETE_REF_SOURCE + Encrption(id)
  );
};

const reActivateRefSource = (id) => {
  return customAxios.get(API_ENDPOINTS.REACTIVATE_REF_SOURCE + Encrption(id));
};

//  ----------------------------- Client Referral Source ------------------------------

const insertClientRefSource = (fields, id) => {
  var data = {
    clientId: id,
    referralSourceId: fields.refName.id,
    referralReason: fields.refReason,
    dateReferral: moment(fields.refDate).format("YYYY-MM-DD"),
  };
  return customAxios.post(API_ENDPOINTS.INSERT_CLIENT_REF_SOURCE, data);
};

const getClientRefSource = (id) => {
  return customAxios.get(API_ENDPOINTS.GET_CLIENT_REF_SOURCE + Encrption(id));
};

const insertClientRefProvider = (fields, id) => {
  var data = {
    clientId: id,
    referralProviderId: fields.refName.id,
    referralReason: fields.refReason,
    dateReferral: moment(fields.refDate).format("YYYY-MM-DD"),
  };
  return customAxios.post(API_ENDPOINTS.INSERT_CLIENT_REF_PROVIDER, data);
};

const getClientRefProvider = (id) => {
  return customAxios.get(API_ENDPOINTS.GET_CLIENT_REF_PROVIDER + Encrption(id));
};

const uploadClinicLogo = (profile, clinicId) => {
  let bodyFormData = new FormData();
  bodyFormData.append("logoFile", profile, profile.path);
  bodyFormData.append("clinicId", clinicId);
  return customAxios.put(API_ENDPOINTS.UPLOAD_CLINIC_LOGO, bodyFormData);
};



const updateDocumentSettings = (fields) => {

  var data = {
    numDaysAllowedInPast: fields.pastAllowedDays ? fields.pastAllowedDays : 0,
    numDaysApplySigAfterDos: fields.daysAppliedSigDos
      ? fields.daysAppliedSigDos
      : 0,
    numDaysApplySigAfterDateLocked: fields.daysAppliedSigLocked
      ? fields.daysAppliedSigLocked
      : 0,
    // allowDocWithoutDiag: fields.allowWithoutDiag,
    canApplySigOnSubmission: fields.signOnSubmission,
    allowDocumentsWithoutAuth: fields.allowDocumentsWithoutAuth === true ? 1 : 0,
    // allowStaffToDuplicateThierOwnDocs:
    //   fields.allowStaffToDuplicateThierOwnDocs === true ? 1 : 0,
    canSubmitAndBillWithNoEligibility:
      fields.canSubmitAndBillWithNoEligibility, 
    canChooseSigDate: fields.canChooseSigDate ? true : false,
    allowBookendingSrvTimes: fields.allowBookendingSrvTimes ? true : false,
    showDocumentHistoryOnPrint: !!fields.showDocumentHistoryOnPrint,
    canUseGoalAfterTargetDate: fields.canUseGoalAfterTargetDate,
    canSubmitDocAfterBusinessHours: fields.canSubmitDocAfterBusinessHours,
    canSignBatchDocuments:fields.canSignBatchDocuments,
    numDaysAllowEditAfterService:fields?.numDaysAllowEditAfterService
    // "canSealDocument":fields.canSealDocument
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_DOCUMENT_SETTINGS, data);
};

const getDocSettings = (clinicId) => {
  return customAxios.get(
    API_ENDPOINTS.GET_DOCUMENT_SETTINGS + Encrption(clinicId)
  );
};

const updateCertificates = (fields) => {
  var data = {
    id: fields.id,
    certificationName: fields.certificateName,
    isRestrictive: fields.isRestrictive,
  };
  return  customAxios.put(API_ENDPOINTS.UPDATE_CERTIFICATES, data);
};

const addCertificates = (fields, clinicId) => {
  var data = {
    clinicId: clinicId,
    certificationName: fields.certificateName,
    isRestrictive: fields.isRestrictive,
  };
  return customAxios.post(API_ENDPOINTS.INSERT_CERTIFICATES, data);
};

const deleteCertificate = (id) => {
  return customAxios.delete(
    API_ENDPOINTS.DELETE_CERTIFICATE + Encrption(id)
  );
};

const addCliniClientFlag = (fields, flagColor) => {
  var data = {
    color: flagColor,
    flagName: fields.flagName,
  };
  return customAxios.post(API_ENDPOINTS.INSERT_CLIENT_FLAG, data);
};

const getClinicFlags = () => {
  return customAxios.get(
    API_ENDPOINTS.GET_CLINIC_CLIENT_FLAGS 
  );
};

const deleteFlag = (id) => {
  return customAxios.delete(
    API_ENDPOINTS.DELETE_FLAG + Encrption(id)
  );
};

const getClinicFlagById = (id) => {
  return customAxios.get(API_ENDPOINTS.GET_FLAG_BY_ID + Encrption(id));
};

const updateCliniClientFlag = (fields, flagColor) => {
  var data = {
    id: fields.id,
    color: flagColor,
    flagName: fields.flagName,
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_CLIENT_FLAG, data);
};

const addCliniClientTags = (fields, tagColor) => {
  var data = {
    color: tagColor,
    tagName: fields.tagName,
  };
  return customAxios.post(API_ENDPOINTS.INSERT_CLINIC_TAG, data);
};

const getClinicTags = (clinicId) => {
  return customAxios.get(
    API_ENDPOINTS.GET_CLINIC_CLIENT_TAGS + Encrption(clinicId) + "&isActive=" + true
  );
};

const deleteTags = (id) => {
  return customAxios.delete(
    API_ENDPOINTS.DELETE_TAG + Encrption(id)
  );
};

const deleteClientStatus = (id) => {
  return customAxios.delete(API_ENDPOINTS.DELETE_CLIENT_STATUS + Encrption(id));
};

const getClinicTagsById = (id) => {
  return customAxios.get(API_ENDPOINTS.GET_TAG_BY_ID + Encrption(id));
};
const getclientStatus = () => {
  return customAxios.get(API_ENDPOINTS.GET_CLIENT_STATUS);
};

const updateCliniClientTags = (fields, tagColor) => {
  var data = {
    id: fields.id,
    color: tagColor,
    tagName: fields.tagName,
  };
  return customAxios.put(API_ENDPOINTS.UPDATE_CLINIC_TAG, data);
};

const addClientStatus = (fields, clinicId) => {
  var data = {
    statusName: fields.statusName,
    clinicId: clinicId,
  };
  return customAxios.post(API_ENDPOINTS.ADD_CLIENT_STATUS, data);
};

const editClientStatus = (fields) => {
  var data = {
    statusName: fields.statusName,
    id: fields.id,
  };
  return customAxios.put(API_ENDPOINTS.EDIT_CLIENT_STATUS, data);
};

const getClientStatusById = (id) => {
  return customAxios.get(API_ENDPOINTS.GET_CLIENT_STATUS_BY_ID+id,);
};

const getClinicDetails = (id) => {
  let ClinicId = (!id || id===null)? localStorage.getItem("clinicId") : id;
  if(!ClinicId ||ClinicId===null ){
     store.dispatch(changeAppRoute(APP_ROUTES.DASHBOARD));
    return
  }
  return customAxios.get(API_ENDPOINTS.GET_CLINIC + Encrption(ClinicId));
};

const saveClientCompliance = (fields: any) => {
  const data = {
    name: fields?.name,
    description: fields?.description,
    startDate: moment(fields?.startDate).format("YYYY-MM-DD"),
    considerationDate: moment(fields?.considerationDate).isValid() ? moment(fields?.considerationDate).format("YYYY-MM-DD") : null,
    useClientStartDate: fields?.useClientStartDate,
    daysAfterStartDate: fields?.daysAfterStartDate,
    isRestrictive: fields?.isRestrictive?.value,
    documentTemplateId: fields?.documentTemplateId?.id,
    contingentUponComplianceId: fields?.contingentUponComplianceId?.clientComplianceId,
    serviceCode: fields?.serviceId?.id,
    adultsOnly: fields?.adultsOnly?.value,
    numDaysAfterComplianceReset: fields?.numDaysAfterComplianceReset,
    isRecurring: fields?.isRecurring,
    payerIds: fields?.payerIds?.map((payer: any) => payer.id),
    siteIds: fields?.siteIds?.map((site: any) => site.id)
  }

  return customAxios.put(API_ENDPOINTS.CREATE_CLIENT_COMPLIANCE, data)
}
const updateClientCompliance = (fields: any, selectedId: number) => {
  const data = {
    id: selectedId,
    name: fields?.name,
    description: fields?.description,
    startDate: moment(fields?.startDate).format("YYYY-MM-DD"),
    considerationDate: moment(fields?.considerationDate).isValid() ? moment(fields?.considerationDate).format("YYYY-MM-DD") : null,
    useClientStartDate: fields?.useClientStartDate,
    daysAfterStartDate: fields?.daysAfterStartDate,
    isRestrictive: fields?.isRestrictive?.value,
    documentTemplateId: fields?.documentTemplateId?.id,
    contingentUponComplianceId: fields?.contingentUponComplianceId?.clientComplianceId,
    serviceCode: fields?.serviceId?.id,
    adultsOnly: fields?.adultsOnly?.value,
    numDaysAfterComplianceReset: fields?.numDaysAfterComplianceReset,
    isRecurring: fields?.isRecurring,
    payerIds: fields?.payerIds?.map((payer: any) => payer.id),
    siteIds: fields?.siteIds?.map((site: any) => site.id)
  }
  return customAxios.post(API_ENDPOINTS.UPDATE_CLIENT_COMPLIANCE, data)
}

const deleteCompliance = (id: any) => {
  return customAxios.delete(API_ENDPOINTS.DELETE_CLIENT_COMPLIANCE + Encrption(id))
}

export const SettingsService = {
  insertClinicReferring,
  getClinicReferringProvider,
  deleteClinicRef,
  reActivateClinicReferring,
  getRefProviderById,
  updateClinicReferring,
  insertRefSource,
  getRefSource,
  getRefSourceById,
  updateRefSource,
  deleteRefSource,
  reActivateRefSource,
  insertClientRefSource,
  getClientRefSource,
  insertClientRefProvider,
  getClientRefProvider,
  uploadClinicLogo,
  updateDocumentSettings,
  getDocSettings,
  updateCertificates,
  deleteCertificate,
  addCertificates,
  addCliniClientFlag,
  getClinicFlags,
  deleteFlag,
  getClinicFlagById,
  updateCliniClientFlag,
  addCliniClientTags,
  getClinicTags,
  deleteTags,
  getClinicTagsById,
  updateCliniClientTags,
  getclientStatus,
  deleteClientStatus,
  addClientStatus,
  editClientStatus,
  getClientStatusById,
  updateClinic,
  getClinicDetails,
  saveClientCompliance,
  updateClientCompliance,
  deleteCompliance,
};


export const getSettings = {
  getClinicLogo: (clinicId: string, inBase64: boolean) => {
    return customAxios.get<any, UserAuthResponse>(`${API_ENDPOINTS.GET_CLINIC_LOGO}${Encrption(clinicId)}&inBase64=${inBase64}`);
  },
}

